import { isCashoutAvailable } from '@tickets/helpers/isCashoutAvailable';
import { BetStateEnum } from '@app/dev/constants/enums/betState';
import { TicketTypes } from '@tickets/constants';
import { store } from '@app/dev/index/terminalApp';
import Config from '@skin_config';
import { getCasinoCopyBetData } from '../mappers';

const isVerificationDone = () => {
  const { verification, startupSettings } = store.getState().terminal;
  return !startupSettings.IsPlayerVerificationEnabled || verification.isVerified;
};

export const isCashout = (ticket) => isVerificationDone() && isCashoutAvailable(ticket) && !Config.main.isViewMode;

const notPayed = (ticket, isPayable, winAmount) => {
  const state = store.getState();

  if (!isVerificationDone()) return;

  if (state.user.loggedIn || state.user.loggedInByRFID) return;

  return (
    (isPayable
      || ticket.ticketType === TicketTypes.DEPOSIT
      || (!isCashout(ticket) && !ticket.dataFromSwarm?.paid_date))
      && winAmount > 0
      && !ticket.paid
  );
};

export const isPay = (ticket, isPayable, winAmount) => notPayed(ticket, isPayable, winAmount) && !Config.main.isViewMode;

export const isSubmitBigWin = (ticket, isPayable, winAmount) => notPayed(ticket, isPayable, winAmount) && winAmount >= Config.main.bigWinAmount;

export const isCopy = (ticket) => {
  if (ticket.ticketType === TicketTypes.CASINO && Config.casino.enableCopyBet) {
    return (
      !!ticket.dataFromCasino && !!getCasinoCopyBetData({ casinoInfo: ticket.dataFromCasino })
    );
  }

  if (ticket.ticketType !== TicketTypes.SPORT) return false;

  return ticket.dataFromSwarm?.selection_list?.some((item) => item.state === BetStateEnum.NotResulted);
};

export const isDetail = (ticket) => ticket.ticketType !== 'deposit';
